import React, { SVGProps } from 'react'
const SvgDesktop = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M5.398 5.5a.897.897 0 0 0-.898.897v8.235c0 .495.402.897.898.897h13.181a.897.897 0 0 0 .898-.897V6.397a.897.897 0 0 0-.898-.897H5.398ZM3 6.397A2.397 2.397 0 0 1 5.398 4h13.181a2.397 2.397 0 0 1 2.398 2.397v8.235a2.397 2.397 0 0 1-2.398 2.397h-5.84v1.644h2.339a.75.75 0 1 1 0 1.5H8.899a.75.75 0 0 1 0-1.5h2.34v-1.644H5.397A2.397 2.397 0 0 1 3 14.632V6.397Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgDesktop
